// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteIndex_timelineCard__DVj4X {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

/* === Верхняя панель === */
.RouteIndex_routeHeader__5veSN {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.8rem 1rem;
  background: #f7f9fc;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

/* === Основная зона: Sidebar + Canvas === */
.RouteIndex_mainRow__7H3bh {
  flex: 1 1;
  display: flex;
  overflow: hidden; /* локальные скроллы не нужны */
}

/* единый вертикальный скролл */
.RouteIndex_scrollArea__nwBKO {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

/* скроллбар */
.RouteIndex_scrollArea__nwBKO::-webkit-scrollbar {
  width: 8px;
}
.RouteIndex_scrollArea__nwBKO::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/timeline/RouteIndex.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,SAAO;EACP,aAAa;EACb,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".timelineCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* === Верхняя панель === */\r\n.routeHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 0.8rem 1rem;\r\n  background: #f7f9fc;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* === Основная зона: Sidebar + Canvas === */\r\n.mainRow {\r\n  flex: 1;\r\n  display: flex;\r\n  overflow: hidden; /* локальные скроллы не нужны */\r\n}\r\n\r\n/* единый вертикальный скролл */\r\n.scrollArea {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* скроллбар */\r\n.scrollArea::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n.scrollArea::-webkit-scrollbar-thumb {\r\n  background: #ccc;\r\n  border-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineCard": `RouteIndex_timelineCard__DVj4X`,
	"routeHeader": `RouteIndex_routeHeader__5veSN`,
	"mainRow": `RouteIndex_mainRow__7H3bh`,
	"scrollArea": `RouteIndex_scrollArea__nwBKO`
};
export default ___CSS_LOADER_EXPORT___;
